import { Component, input } from '@angular/core';

import { MissingCropFieldDataNotificationDto } from '../../../shared/models/models';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-missing-cropfield-data-body',
    templateUrl: './missing-cropfield-data-body.component.html',
    styleUrls: ['./missing-cropfield-data-body.component.scss'],
    imports: [TranslatePipe],
})
export class MissingCropFieldDataBodyComponent {
    notification = input.required<MissingCropFieldDataNotificationDto>();
}
